import styled from 'styled-components';

const StyledMain = styled.main`
  overflow: scroll;
  flex: 1 0 auto;
`;

export default StyledMain;
